import React, { useEffect, useState } from 'react';
import { formatSeoApiError, listRoutes, fetchRouteFares } from '../../../utils/adminSeo';

export default function SeoFaresScreen() {
  const [routes, setRoutes] = useState([]);
  const [selected, setSelected] = useState(null);
  const [fares, setFares] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    setErr('');
    listRoutes(50)
      .then((r) => setRoutes(r.routes || []))
      .catch((e) => setErr(formatSeoApiError(e)));
  }, []);

  const load = (id) => {
    setSelected(id);
    setErr('');
    fetchRouteFares(id)
      .then(setFares)
      .catch((e) => setErr(formatSeoApiError(e)));
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Fare Cache Manager</h2>
      {err && <p className="text-red-600 text-sm">{err}</p>}
      <select className="border rounded px-2 py-1 text-sm" onChange={(e) => load(e.target.value)} defaultValue="">
        <option value="">Select route…</option>
        {routes.map((r) => (
          <option key={r.id} value={r.id}>{r.slug}</option>
        ))}
      </select>
      {fares && (
        <pre className="text-xs bg-gray-50 border rounded p-3 overflow-auto max-h-96">
          {JSON.stringify(fares, null, 2)}
        </pre>
      )}
    </div>
  );
}
